import { Flex, Text } from "@theorgchartdev/storybook";
import { MoreFieldsListPopover } from "@/appComponents/Blocks/Cards/SourceInfoCard/MoreFieldsListPopover";
import { appstr } from "@coreapp/utils/appstr";

export const LayoutRecordDetails = ({ layout }) => {
  if (!layout) return;
  const numShown = 3;
  const layoutFields = layout.GetUsedFields() ?? [];
  const fieldsInUse = layoutFields.map(fieldDef => fieldDef.GetFieldName());
  const displayFields = fieldsInUse.slice(0, numShown).join(", ");
  const showMoreFieldsPopover = fieldsInUse.length > numShown;

  const fieldLabelProps = {
    size: "xsmall",
    colorModifier: "grey",
    modifier: "bold"
  };

  const valueLabelProps = {
    size: "xsmall"
  };

  return (
    <Flex direction={"column"} gap={"2px"}>
      <Text {...fieldLabelProps}>{appstr("Fields shown")}</Text>
      <Flex>
        <Text {...valueLabelProps}>{displayFields}</Text>
        {showMoreFieldsPopover && (
          <MoreFieldsListPopover fields={fieldsInUse} numberShown={numShown} size={"xsmall"} />
        )}
      </Flex>
    </Flex>
  );
};
